import type { RouteObject } from "react-router-dom";
import { Navigate, useLocation, useParams } from "react-router-dom";

function LegacyDashboardsRedirect() {
  const { fileId } = useParams();
  const location = useLocation();
  return (
    <Navigate
      to={`../library/dashboards${fileId ? `/${fileId}` : ""}${location.search}${location.hash}`}
      replace
    />
  );
}

export const dashboardRoutes: RouteObject[] = [
  { path: "dashboards", element: <LegacyDashboardsRedirect /> },
  { path: "dashboards/:fileId", element: <LegacyDashboardsRedirect /> },
];
